import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { Link } from "@tanstack/react-router";
import useTranslation from "../hooks/useTranslation";

export default function NotFoundScreen() {
  const { translate } = useTranslation();

  return (
    <div className="flex min-h-dvh items-center justify-center bg-slate-50 px-4">
      <div className="flex max-w-sm flex-col items-center gap-4 text-center">
        <div className="rounded-full bg-slate-100 p-4">
          <ArrowPathIcon className="h-8 w-8 text-slate-400" />
        </div>
        <h2 className="text-lg font-semibold text-slate-800">
          {translate("not_found_title")}
        </h2>
        <p className="text-sm leading-relaxed text-slate-500">
          {translate("not_found_body")}
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link
            to="/app/reeprise"
            search={{ mobileView: undefined }}
            className="rounded-md bg-slate-800 px-6 py-2.5 text-sm font-medium text-white hover:bg-slate-700 active:bg-slate-900"
          >
            {translate("not_found_primary_action")}
          </Link>
          <Link
            to="/app/product_logbook"
            className="rounded-md border border-slate-300 bg-white px-6 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50"
          >
            {translate("not_found_secondary_action")}
          </Link>
        </div>
      </div>
    </div>
  );
}
